import * as Yup from 'yup'

import { formValidationSchemaNoChanged } from '../../../../../Form'
import { toUserSelectItem } from '../../../../../User'

import {
  LISTING_RESPONSIBLE_MANAGER_FIELD_NAME,
  LISTING_RESPONSIBLE_MANAGER_PAYLOAD_FIELD_NAME,
} from './ListingResponsibleManagerModal.constants'

function isListingResponsibleManagerEqual({ initialValues, values }) {
  return (
    initialValues[LISTING_RESPONSIBLE_MANAGER_FIELD_NAME]?.value ===
    values[LISTING_RESPONSIBLE_MANAGER_FIELD_NAME]?.value
  )
}

export function toListingResponsibleManagerSelectItem(user) {
  return user
    ? toUserSelectItem({
        ...user,
        archived: user.is_archived,
        company_post_name: user.job_title,
        fullname: user.full_name,
      })
    : null
}

export function getListingResponsibleManagerInitialValues(responsibleManager) {
  return {
    [LISTING_RESPONSIBLE_MANAGER_FIELD_NAME]:
      toListingResponsibleManagerSelectItem(responsibleManager),
  }
}

export function getListingResponsibleManagerPayload(values) {
  return {
    [LISTING_RESPONSIBLE_MANAGER_PAYLOAD_FIELD_NAME]:
      values[LISTING_RESPONSIBLE_MANAGER_FIELD_NAME]?.value ?? null,
  }
}

export function getListingResponsibleManagerValidationSchema({
  initialValues,
}) {
  return Yup.object({
    [LISTING_RESPONSIBLE_MANAGER_FIELD_NAME]: Yup.object().nullable(),
  }).concat(
    formValidationSchemaNoChanged({
      initialValues,
      isEqual: isListingResponsibleManagerEqual,
    })
  )
}
